<template>
  <div class="grid grid-cols-2 gap-2">
    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-700">{{ $t("users.create_user.password") + '*' }}</label>
      <Password
        :model-value="password"
        :feedback="false"
        toggleMask
        inputClass="w-full"
        class="w-full"
        autocomplete="new-password"
        @update:model-value="$emit('update:password', $event)"
        @blur="touched.password = true"
      />
      <small v-if="touched.password && passwordValidationError" class="text-red-500 text-xs">{{ passwordValidationError }}</small>
    </div>
    <div class="flex flex-col gap-2">
      <label class="text-sm text-gray-700">{{ $t("users.create_user.password_confirm") + '*' }}</label>
      <Password
        :model-value="confPassword"
        :feedback="false"
        toggleMask
        inputClass="w-full"
        class="w-full"
        autocomplete="new-password"
        @update:model-value="$emit('update:confPassword', $event)"
        @blur="touched.confPassword = true"
      />
      <small v-if="touched.confPassword && confirmPasswordValidationError" class="text-red-500 text-xs">{{ confirmPasswordValidationError }}</small>
    </div>
  </div>
</template>

<script>
import { Password } from 'primevue';

export default {
  name: 'PasswordSection',
  components: {
    Password,
  },
  props: {
    password: {
      type: String,
      required: true,
    },
    confPassword: {
      type: String,
      required: true,
    },
    showPass: {
      type: Boolean,
      required: true,
    },
    showConf: {
      type: Boolean,
      required: true,
    },
    passwordRules: {
      type: Array,
      required: true,
    },
    confirmPasswordRules: {
      type: Array,
      required: true,
    },
    passwordConfirmationRule: {
      type: Function,
      required: true,
    },
  },
  emits: ['update:password', 'update:confPassword', 'update:showPass', 'update:showConf'],
  data() {
    return {
      touched: {
        password: false,
        confPassword: false,
      },
    };
  },
  computed: {
    passwordValidationError() {
      for (const rule of this.passwordRules) {
        const result = rule(this.password);
        if (result !== true) return result;
      }
      return null;
    },
    confirmPasswordValidationError() {
      const rules = this.confirmPasswordRules.concat(this.passwordConfirmationRule);
      for (const rule of rules) {
        const result = rule(this.confPassword);
        if (result !== true) return result;
      }
      return null;
    },
  },
};
</script> 